<template>
  <v-dialog lazy v-model="opened" max-width="256px">
    <v-avatar slot="activator" class="elevation-0 mr-3">
      <img v-if="src" :src="src" />
    </v-avatar>

    <!-- Avatar Upload Dialog -->
    <v-card dark class="logo__upload">
      <v-card-title class="title">
        Upload a New Logo
      </v-card-title>
      <v-img v-if="src" :src="image && preview ? preview : src" height="256px">
        <v-layout fill-height column align-end justify-end>
          <v-btn
            @click.native="$refs.file.click()"
          >
            Select Image
          </v-btn>
        </v-layout>
        <input type="file" name="file" ref="file" @change="setFile" style="display: none;" />
      </v-img>
      <v-card-actions>
        <v-spacer />
        <v-btn flat @click="opened = false">cancel</v-btn>
        <v-btn
          @click="submit"
          :disabled="!image"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// Vue Component
export default {
  props: { src: String, path: String },
  data() {
    return {
      opened: false,
      image: null,
      preview: null
    }
  },
  methods: {
    setFile() {
      this.image = this.$refs.file.files[0]
      const reader = new FileReader()
      reader.addEventListener('load', () => (this.preview = reader.result), false)
      if (this.image) reader.readAsDataURL(this.image)
    },
    submit() {
      if (this.image) {
        let logoData = new FormData()
        logoData.append('logo', this.image)
        this.$http
          .post(this.path, logoData, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then(() => this.$emit('success'))
          .then(() => (this.opened = false))
      }
    }
  }
}
</script>

<style lang="css">
.logo__upload .v-image__image {
  border-radius: 50%;
}
</style>
